module.exports = __webpack_public_path__ + "static/vincent_meunier-c53ba44ee3cf8cfafd9bfc58e432afa0.jpg";